<script setup lang="ts">
import { Text, computed, useSlots } from "vue"

const slots = useSlots()
const hasContent = computed(() => {
  // no slot at all
  if (!slots.default) return false

  // render the slot to get its VNodes
  const vnodes = slots.default()

  // nothing rendered
  if (vnodes.length === 0) return false

  // check each VNode: if it’s a Text node with only whitespace → skip
  // any other node (element, component, or non-empty text) → we have content
  return vnodes.some((vnode) => {
    if (vnode.type === Text) {
      return typeof vnode.children === "string" && vnode.children.trim() !== ""
    }
    return true
  })
})

const { name } = defineProps({
  name: { type: String, required: true },
  verticalAlign: { type: String, default: "top" },
})
</script>

<template>
  <tr>
    <th :class="verticalAlign">{{ name }}</th>
    <td :class="verticalAlign">
      <slot v-if="hasContent" />
      <span v-else>-</span>
    </td>
  </tr>
</template>

<style scoped>
th,
td {
  border: none;
  vertical-align: top !important;
}

th.top,
td.top {
  vertical-align: top !important;
}

th.middle,
td.middle {
  vertical-align: middle !important;
}

th.bottom,
td.bottom {
  vertical-align: bottom !important;
}

th {
  width: 1%;
  white-space: nowrap;
  padding: 0 1rem 0.5rem 0;
}

td {
  padding: 0 0 0.5rem 0;
}
</style>
